import request from '@jarvis.oddle/core/tools/request'
import { NEW_RELIC_APP_NAME, NEW_RELIC_LICENSE_KEY } from '@jarvis.oddle/core/env'
import { isObjectEmpty } from '@jarvis.oddle/core/tools/object'

export const newrelicPath = '/newrelic'

const call = async ({ req, res, next, method = 'GET', uri }) => {
  const options = {
    uri,
    method,
    headers: {
      'X-License-Key': NEW_RELIC_LICENSE_KEY,
      'Content-Type': 'application/json'
    }
  }

  if (!isObjectEmpty(req.body)) {
    options.body = JSON.stringify({
      ...req.body,
      timestamp: new Date().getTime(),
      service: NEW_RELIC_APP_NAME
    })
  }

  try {
    const response = await request(options)
    if (response.body) {
      const json = JSON.parse(response.body)
      return res.status(response.statusCode).json(json)
    } else {
      return res.status(response.statusCode).send()
    }
  } catch (error) {
    next(new Error(error))
  }
}

export function createApi (express, apiRoot) {
  const router = new express.Router()

  router.post('/', (req, res, next) => call({ req, res, next, method: 'POST', uri: 'https://log-api.newrelic.com/log/v1' }))

  return [`${apiRoot}${newrelicPath}`, router]
}
